<template>
  <div class="pa-2">
    <FormTemplateFieldSelector
      :templateID="$route.params.id"
      v-if="!loading && fieldSelecting"
      @select="fieldSelecting = false;editsection.conditional_question_id = arguments[0].question_id; editsection.conditional_fieldtype_id = arguments[0].fieldtype_id"
      @cancel="fieldSelecting = false"
    />
    
    <div class="d-flex align-center justify-space-between mb-4" style="width: 100%;">
      <div class="text-h6 text-truncate" style="min-width: 0; flex-shrink: 1;">Section Properties</div>
      <div class="d-flex align-center flex-shrink-0 ml-2">
        <v-btn small text dense @click="$emit('cancel')">Cancel</v-btn>
        <v-btn small color="info" @click="save()" class="ml-2">Save</v-btn>
      </div>
    </div>

    <v-text-field
      v-model="editsection.number"
      autofocus
      label="Number"
      :hide-details="true"
      class="mb-4"
    />

    <v-text-field
      v-if="!htmlTitle"
      v-model="editsection.text"
      label="Title"
      :hide-details="true"
      class="mb-2"
    />

    <div v-else class="mb-2">
      <div class="text-caption mb-1" style="color: rgba(0, 0, 0, 0.6);">Title</div>
      <Editor
        ref="titleHtmlEditor"
        :html="editsection.text"
        style="background: white; border: 1px solid rgba(0,0,0,0.4); border-radius: 4px;"
      />
    </div>

    <v-btn
      v-if="section.section"
      text
      small
      class="mb-4 px-0"
      @click="toggleHtml()"
    >
      {{ htmlTitle ? 'Edit as Plain Text' : 'Edit as HTML' }}
    </v-btn>

    <div style="position: relative;">
      <Preloader v-if="loading" />
      
      <v-divider class="my-4" />
      
      <div class="text-subtitle-2 mb-2">Display Settings</div>
      <v-checkbox
        v-model="editsection.web_only"
        label="Web Only"
        class="mt-0 mb-2"
        persistent-hint
        hint="Do not show section on PDF"
      />
      <v-checkbox
        v-model="editsection.pdf_only"
        label="PDF Only"
        class="mt-0 mb-2"
        persistent-hint
        hint="Do not show on Web"
      />
      <v-checkbox
        v-model="editsection.web_collapsible"
        label="Collapsible"
        class="mt-0 mb-2"
        persistent-hint
        hint="Allow users to collapse section"
      />
      <v-checkbox
        v-model="editsection.read_only"
        label="Read Only"
        class="mt-0 mb-4"
        persistent-hint
        hint="Make all questions read only."
      />

      <v-divider class="my-4" />

      <div class="text-subtitle-2 mb-2">Tip Dialog Text</div>
      <Editor
        :enable_formatting='editsection.web_only'
        ref="tipHtmlEditor"
        :html="section.tip_text"
        style="background: white;"
      />

      <v-divider class="my-4" />

      <div class="text-subtitle-2 mb-2">Conditional Visibility</div>
      <v-checkbox
        v-model="conditional_part"
        label="Conditional Form Part"
        class="mt-0 mb-4"
        persistent-hint
        hint="Display part depending on answer"
      />
      
      <div v-if="conditional_part" class="pl-3" style="border-left: 2px solid #eee;">
        <v-text-field
          v-model="editsection.conditional_question_id"
          label="Question ID"
          disabled
          hide-details="auto"
          class="mb-4"
        />
        <v-text-field
          v-model="editsection.conditional_fieldtype_id"
          label="Fieldtype ID"
          disabled
          hide-details="auto"
          class="mb-4"
        />
        <v-text-field
          v-model="editsection.conditional_value"
          label="Conditional Value"
          hide-details="auto"
          class="mb-4"
        />
        <v-checkbox
          v-model="editsection.conditional_apply_pdf"
          label="Apply to PDF"
          hide-details="auto"
          class="mt-0 mb-4"
          persistent-hint
          hint="Hide from PDF if part fails condition"
        />
        <v-btn
          small
          outlined
          @click="fieldSelecting = true"
          class="mb-4"
        >
          Select a field
        </v-btn>
      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import Preloader from '@/components/global/Preloader'
import Editor from '@/components/admin/Editor'
import FormTemplateFieldSelector from '@/components/admin/FormTemplateFieldSelector'

export default {
  name: 'SectionProperties',
  props: [ 'partId', 'newPart' ],
  components: {

    Preloader,
    Editor,
    FormTemplateFieldSelector
  },
  data () {
    return {
      editsection: {},
      loading: false,
      htmlTitle: false,
      displayAdditional: false,
      conditional_part: false,
      fieldSelecting: false
    }
  },
  computed: {
    ...mapGetters('formtemplate', [
      'partById'
    ]),

    section: function () {
      return this.partById(this.partId) || this.newPart
    }
  },
  created () {
    this.editsection = JSON.parse(JSON.stringify(this.section))
    this.conditional_part = (this.editsection.conditional_question_id)
    var htmlTag = /<[a-z][\s\S]*>/i
    if (htmlTag.test(this.editsection.text)) {
      this.htmlTitle = true
    }
  },
  methods: {
    ...mapActions('formtemplate', [
      'saveSection'
    ]),
    toggleHtml () {
      if (this.htmlTitle) {
        if (this.$refs.titleHtmlEditor) {
          const rawHtml = this.$refs.titleHtmlEditor.getHTML()
          const tempDiv = document.createElement('div')
          tempDiv.innerHTML = rawHtml
          this.editsection.text = tempDiv.textContent || tempDiv.innerText || ''
        }
        this.htmlTitle = false
      } else {
        this.htmlTitle = true
      }
    },
    save () {
      this.loading = true
      if (this.htmlTitle && this.$refs.titleHtmlEditor) {
        this.editsection.text = this.$refs.titleHtmlEditor.getHTML()
      }
      this.editsection.tip_text = this.getTipHTML()
      if(!this.conditional_part){
        this.editsection.conditional_question_id = null
        this.editsection.conditional_fieldtype_id = null
        this.editsection.conditional_apply_pdf = false
        this.editsection.conditional_value = ""
      }
      this.saveSection(this.editsection)
      .then(section => {
        this.$emit('save', section)
        this.loading = false
      })
    },
    getTipHTML () {
      var html = this.$refs.tipHtmlEditor.getHTML()
      if (html.replace(/<\/?[^>]+(>|$)/g, "").replace(" ", "") !== "") {
        return this.$refs.tipHtmlEditor.getHTML()
      } else {
        return null
      }
    }
  }
}
</script>

<style scoped>
.adv_settings {
    padding:0 10px;
    padding: 0 25px 0 25px;
    border-top: 1px solid rgba(0,0,0,0.1)
}
</style>
